import { AuditLogSearchCriteria } from "domain/entity/AuditLog/AuditLogSearchCriteria";
import { getDefaultBuConfig } from "domain/repository/apiUtil";
import { AuditLogMaintenanceConstant } from "presentation/constant/AuditLog/AuditLogMaintenanceConstant";
import { auditLogIncidentDropdownOption, auditLogTypeDropdownOption } from "presentation/constant/DropDownOptions/StaticDropdownOptions";
import { useAuditLogMaintenanceVM } from "presentation/hook/AuditLog/useAuditLogMaintenanceVM";
import { useMessageBarVM } from "presentation/hook/useMessageBar";
import { useAuditLogMaintenanceTracked } from "presentation/store/AuditLog/AuditLogMaintenanceProvider";
import { CriteriaItemContainer } from "presentation/view/components/CriteriaItemContainer";
import { NbisCommonField } from "presentation/view/components/NbisCommonField";
import NbisDateTimePickerComponent from "presentation/view/components/NbisDateTimePickerComponent";
import { useCallback, useMemo, useState } from "react";
import { FieldType, HPHButton, HPHInputTextarea, IconButton, IFieldValue, Loader } from "veronica-ui-component/dist/component/core";
import { SidebarActionBar, SidebarActionCross, Sidebarheader, SidebarTitle } from "veronica-ui-component/dist/component/core/styled/uiFramework.styled";

export const AuditLogSearchPanel = () => {
    const SCREEN_CONSTANT = AuditLogMaintenanceConstant;
    const [auditLogState] = useAuditLogMaintenanceTracked();
    const auditLogVM = useAuditLogMaintenanceVM();
    const { searchCriteria } = auditLogState;
    const [isLoading, setIsLoading] = useState<boolean>(false);
    const messageBarVM = useMessageBarVM();
    const blNoMaxLength: number = getDefaultBuConfig<number>("REACT_APP_BILL_OF_LADING_MAX_LENGTH") || 35;

    const resetButtonClicked = useCallback(() => {
        auditLogVM.onRemoveAllSearchCriteria();
    }, [auditLogVM]);

    const searchButtonClicked = useCallback((criteria: AuditLogSearchCriteria) => {
        if (!criteria.auditLogType || !criteria.updatedDateFrom || !criteria.updatedDateTo) {
            messageBarVM.showError("Must input Updated Date From/Updated Date To/Audit Log Type first.");
            return;
        }
        setIsLoading(true);
        auditLogVM.setIsSearchLoading(true);
        auditLogVM.onSearch(criteria).then((data) => {
            setIsLoading(false);
            auditLogVM.setIsSearchLoading(false);
        }).catch(error => {
            setIsLoading(false);
            auditLogVM.setIsSearchLoading(false);
        })
    }, [auditLogVM, messageBarVM]);

    const memoUpdatedDateFrom = useMemo(() =>
        <div className='im-flex-row-item' style={{ width: "220px", marginBottom: "20px" }}>
            {/* <DateRangePickerComponent
                label={SCREEN_CONSTANT.UPDATED_DATE_RANGE}
                width='470px'
                fieldNames={{ startField: "updatedDateFrom", endField: "updatedDateTo" }}
                dateRange={{ startDate: searchCriteria.updatedDateFrom, endDate: searchCriteria.updatedDateTo }}
                onDatesChange={auditLogVM.onDateRangeChange}
            /> */}
            <NbisDateTimePickerComponent
                disabled={false}
                label={SCREEN_CONSTANT.UPDATED_DATE_FROM}
                width="220px"
                date={searchCriteria?.updatedDateFrom ?? null}
                fieldName="updatedDateFrom"
                onDateChange={(fieldKey: string, fieldValue: IFieldValue) =>
                    auditLogVM.onSearchFieldChange(fieldKey, fieldValue)} />
        </div>
        , [SCREEN_CONSTANT.UPDATED_DATE_FROM, auditLogVM, searchCriteria?.updatedDateFrom])
    const memoUpdatedDateTo = useMemo(() =>
        <div className='im-flex-row-item' style={{ width: "220px", marginBottom: "20px" }}>
            {/* <DateRangePickerComponent
                label={SCREEN_CONSTANT.UPDATED_DATE_RANGE}
                width='470px'
                fieldNames={{ startField: "updatedDateFrom", endField: "updatedDateTo" }}
                dateRange={{ startDate: searchCriteria.updatedDateFrom, endDate: searchCriteria.updatedDateTo }}
                onDatesChange={auditLogVM.onDateRangeChange}
            /> */}
            <NbisDateTimePickerComponent
                disabled={false}
                label={SCREEN_CONSTANT.UPDATED_DATE_TO}
                width="220px"
                date={searchCriteria?.updatedDateTo ?? null}
                fieldName="updatedDateTo"
                onDateChange={(fieldKey: string, fieldValue: IFieldValue) =>
                    auditLogVM.onSearchFieldChange(fieldKey, fieldValue)} />
        </div>
        , [SCREEN_CONSTANT.UPDATED_DATE_TO, auditLogVM, searchCriteria?.updatedDateTo])

    const memoCntrNos = useMemo(() =>
        <div className='im-flex-row-item' style={{ width: "470px", marginBottom: "20px" }}>
            <HPHInputTextarea
                label={SCREEN_CONSTANT.CNTR_NO}
                width="470px"
                rows={3}
                resizable={false}
                helpIcon={true}
                toolTipText={"Use line break ( Enter ) as delimiter"}
                errorMessage={''}
                value={searchCriteria.cntrNos?.join('\n') ?? []}
                onChange={(e) => { auditLogVM.onTextAreaChange(e, "cntrNos", true) }} />
        </div>
        , [SCREEN_CONSTANT.CNTR_NO, auditLogVM, searchCriteria.cntrNos])


    const memoOpsLine = useMemo(() =>
        <div className='im-flex-row-item' style={{ width: "220px", marginBottom: "20px" }}>
            <NbisCommonField
                errorMessages={{}}
                isReadOnly={false}
                isShowOptional={false}
                readOnlyValue={searchCriteria?.opsLines?.join(',')}
                fieldValue={searchCriteria?.opsLines}
                fieldLabel={SCREEN_CONSTANT.OPS_LINE}
                isSaveClicked={false}
                fieldType={FieldType.DROPDOWN}
                fieldKey={'opsLines'}
                maxLength={60}
                isMultipleDropDown={true}
                options={auditLogState.dynamicOptions.opsLineDropdownOptions}
                requiredFieldList={[]}
                onFieldChange={(fieldKey: string, fieldValue: IFieldValue, fFullValue?: any) =>
                    auditLogVM.onSearchFieldChange(fieldKey, fieldValue && fieldValue, fFullValue)} />
        </div>
        , [SCREEN_CONSTANT.OPS_LINE, auditLogState.dynamicOptions.opsLineDropdownOptions, auditLogVM, searchCriteria?.opsLines])

    const memoForwarderCodes = useMemo(() =>
        <div className='im-flex-row-item' style={{ width: "220px", marginBottom: "20px" }}>
            <NbisCommonField
                errorMessages={{}}
                isReadOnly={false}
                isShowOptional={false}
                readOnlyValue={searchCriteria?.forwarderCodes?.join(',')}
                fieldValue={searchCriteria?.forwarderCodes}
                fieldLabel={SCREEN_CONSTANT.FORWARDER_CODE}
                isSaveClicked={false}
                isMultipleDropDown={true}
                fieldType={FieldType.DROPDOWN}
                fieldKey={'forwarderCodes'}
                maxLength={60}
                options={auditLogState.dynamicOptions.forwarderCodeDropdownOptions}
                requiredFieldList={[]}
                onFieldChange={(fieldKey: string, fieldValue: IFieldValue, fFullValue?: any) =>
                    auditLogVM.onSearchFieldChange(fieldKey, fieldValue && fieldValue, fFullValue)} />
        </div>
        , [SCREEN_CONSTANT.FORWARDER_CODE, auditLogState.dynamicOptions.forwarderCodeDropdownOptions, auditLogVM, searchCriteria?.forwarderCodes])

    const memoAuditLogType = useMemo(() =>
        <div className='im-flex-row-item' style={{ width: "470px", marginBottom: "20px" }}>
            <NbisCommonField
                errorMessages={{}}
                isReadOnly={false}
                isShowOptional={false}
                readOnlyValue={searchCriteria?.auditLogType ?? ""}
                fieldValue={searchCriteria?.auditLogType}
                fieldLabel={SCREEN_CONSTANT.AUDIT_LOG_TYPE}
                isSaveClicked={false}
                fieldType={FieldType.DROPDOWN}
                fieldKey={'auditLogType'}
                maxLength={60}
                options={auditLogTypeDropdownOption}
                requiredFieldList={[]}
                onFieldChange={(fieldKey: string, fieldValue: IFieldValue, fFullValue?: any) =>
                    auditLogVM.onSearchFieldChange(fieldKey, fieldValue && fieldValue.toString(), fFullValue)} />
        </div>
        , [SCREEN_CONSTANT.AUDIT_LOG_TYPE, auditLogVM, searchCriteria?.auditLogType])

    const memoUserId = useMemo(() =>
        <div className='im-flex-row-item' style={{ width: "220px", marginBottom: "20px" }}>
            <NbisCommonField
                errorMessages={{}}
                isReadOnly={false}
                isShowOptional={false}
                readOnlyValue={searchCriteria?.userId ?? ""}
                fieldValue={searchCriteria?.userId}
                fieldLabel={SCREEN_CONSTANT.USER_ID}
                isSaveClicked={false}
                fieldType={FieldType.DROPDOWN}
                fieldKey={'userId'}
                maxLength={60}
                options={auditLogState.dynamicOptions.userDropdownOptions}
                requiredFieldList={[]}
                onFieldChange={(fieldKey: string, fieldValue: IFieldValue, fFullValue?: any) =>
                    auditLogVM.onSearchFieldChange(fieldKey, fieldValue && fieldValue.toString(), fFullValue)} />
        </div>
        , [SCREEN_CONSTANT.USER_ID, auditLogState.dynamicOptions.userDropdownOptions, auditLogVM, searchCriteria?.userId])

    const memoAuditLogIncident = useMemo(() =>
        <div className='im-flex-row-item' style={{ width: "470px", marginBottom: "20px" }}>
            <NbisCommonField
                errorMessages={{}}
                isReadOnly={false}
                isShowOptional={false}
                readOnlyValue={searchCriteria?.auditLogIncident ?? ""}
                fieldValue={searchCriteria?.auditLogIncident}
                fieldLabel={SCREEN_CONSTANT.AUDIT_LOG_INCIDENT}
                isSaveClicked={false}
                fieldType={FieldType.DROPDOWN}
                fieldKey={'auditLogIncident'}
                maxLength={60}
                options={auditLogIncidentDropdownOption}
                requiredFieldList={[]}
                onFieldChange={(fieldKey: string, fieldValue: IFieldValue, fFullValue?: any) =>
                    auditLogVM.onSearchFieldChange(fieldKey, fieldValue && fieldValue.toString(), fFullValue)} />
        </div>
        , [SCREEN_CONSTANT.AUDIT_LOG_INCIDENT, auditLogVM, searchCriteria?.auditLogIncident])


    const memoBillOfLading = useMemo(() =>
        <div className='im-flex-row-item' style={{ width: "220px", marginBottom: "20px" }}>
            <NbisCommonField
                errorMessages={{}}
                isReadOnly={false}
                isShowOptional={false}
                readOnlyValue={searchCriteria?.billOfLading ?? ""}
                fieldValue={searchCriteria?.billOfLading}
                fieldLabel={SCREEN_CONSTANT.BILL_OF_LADING}
                isSaveClicked={false}
                fieldType={FieldType.TEXT}
                fieldKey={'billOfLading'}
                maxLength={blNoMaxLength}
                requiredFieldList={[]}
                onFieldChange={(fieldKey: string, fieldValue: IFieldValue, fFullValue?: any) =>
                    auditLogVM.onSearchFieldChange(fieldKey, fieldValue && fieldValue.toString(), fFullValue)} />
        </div>
        , [SCREEN_CONSTANT.BILL_OF_LADING, auditLogVM, blNoMaxLength, searchCriteria?.billOfLading])

    const memoShippingBill = useMemo(() =>
        <div className='im-flex-row-item' style={{ width: "220px", marginBottom: "20px" }}>
            <NbisCommonField
                errorMessages={{}}
                isReadOnly={false}
                isShowOptional={false}
                readOnlyValue={searchCriteria?.shippingBill ?? ""}
                fieldValue={searchCriteria?.shippingBill}
                fieldLabel={SCREEN_CONSTANT.SHIPPING_BILL}
                isSaveClicked={false}
                fieldType={FieldType.TEXT}
                fieldKey={'shippingBill'}
                maxLength={35}
                requiredFieldList={[]}
                onFieldChange={(fieldKey: string, fieldValue: IFieldValue, fFullValue?: any) =>
                    auditLogVM.onSearchFieldChange(fieldKey, fieldValue && fieldValue.toString(), fFullValue)} />
        </div>
        , [SCREEN_CONSTANT.SHIPPING_BILL, auditLogVM, searchCriteria?.shippingBill])

    const memoProposalNo = useMemo(() =>
        <div className='im-flex-row-item' style={{ width: "220px", marginBottom: "20px" }}>
            <NbisCommonField
                errorMessages={{}}
                isReadOnly={false}
                isShowOptional={false}
                readOnlyValue={searchCriteria?.proposalNo ?? ""}
                fieldValue={searchCriteria?.proposalNo}
                fieldLabel={SCREEN_CONSTANT.PROPOSAL_NO}
                isSaveClicked={false}
                fieldType={FieldType.TEXT}
                fieldKey={'proposalNo'}
                maxLength={7}
                requiredFieldList={[]}
                onFieldChange={(fieldKey: string, fieldValue: IFieldValue, fFullValue?: any) =>
                    auditLogVM.onSearchFieldChange(fieldKey, fieldValue && fieldValue.toString(), fFullValue)} />
        </div>
        , [SCREEN_CONSTANT.PROPOSAL_NO, auditLogVM, searchCriteria?.proposalNo])



    return <div className='side-form-content-left-wrapper' style={{ padding: "20px 20px 20px 0px" }}>
        <div className={'flex-row'}>
            <div className={'flex-row-item flex-row-item-full-width'}>
                <Sidebarheader>
                    <SidebarTitle>{'Search Criteria'}</SidebarTitle>
                    <SidebarActionCross>
                        <IconButton
                            fileName="Icon-cross" size="medium" toolTipText='Close' toolTipArrow={false} onClick={auditLogVM.onSearchClick} />
                    </SidebarActionCross>
                </Sidebarheader>
            </div>
        </div>

        {isLoading && <Loader Indicator="Spinner" size="Medium" />}

        <div className={'add-edit-form'} style={{ height: '75vh', maxHeight: '75vh', overflow: 'auto' }}>
            <div className="flex-row-auto">
                <div className={'flex-row-item'}>
                    <CriteriaItemContainer>
                        {memoAuditLogType}
                    </CriteriaItemContainer>
                    <CriteriaItemContainer>
                        {memoAuditLogIncident}
                    </CriteriaItemContainer>
                    <CriteriaItemContainer>
                        {memoUpdatedDateFrom}
                        {memoUpdatedDateTo}
                    </CriteriaItemContainer>
                    <CriteriaItemContainer>
                        {memoOpsLine}
                        {memoForwarderCodes}
                    </CriteriaItemContainer>
                    <CriteriaItemContainer>
                        {memoUserId}
                        {memoProposalNo}
                    </CriteriaItemContainer>
                    <CriteriaItemContainer>
                        {memoBillOfLading}
                        {memoShippingBill}
                    </CriteriaItemContainer>
                    <CriteriaItemContainer>
                        {memoCntrNos}
                    </CriteriaItemContainer>
                </div>
            </div>
        </div>
        <SidebarActionBar>
            <HPHButton label={'Reset'} size={'Small'} theme={'Secondary'} onClick={resetButtonClicked} />
            <HPHButton label={'Search'} size={'Small'} theme={'Primary'} onClick={() => searchButtonClicked(searchCriteria)} />
        </SidebarActionBar>
    </div>
}
